import { defineNuxtPlugin } from '#imports';
import { Lazyload } from 'vant';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(Lazyload, {"lazyComponent":true});
})
